import type { Balance } from '../lib/balance';
import type { MealType } from '../types';

const LABELS: { key: keyof Omit<Balance, 'total'>; label: string }[] = [
  { key: 'protein', label: 'Protein' },
  { key: 'grain', label: 'Grain' },
  { key: 'veggie', label: 'Veggie' },
  { key: 'fruit', label: 'Fruit' },
  { key: 'fat', label: 'Fat' },
];

const MEAL_LABEL: Record<MealType, string> = {
  lunch: 'Lunch', dinner: 'Dinner', breakfast: 'Breakfast', snack: 'Snack',
};

export function BalanceBanner(props: {
  balances: { mealType: MealType; balance: Balance }[];
  onDismiss?: () => void;
}) {
  return (
    <div style={{
      position: 'relative',
      padding: '8px 12px',
      fontSize: 12,
      display: 'flex', flexDirection: 'column', gap: 6,
      paddingRight: props.onDismiss ? 32 : 12,
    }}>
      {props.balances.map(({ mealType, balance }) => (
        <BalanceRow key={mealType} mealType={mealType} balance={balance} />
      ))}
      {props.onDismiss && (
        <button
          onClick={props.onDismiss}
          aria-label="Dismiss balance summary"
          style={{
            position: 'absolute', top: 4, right: 4,
            width: 24, height: 24, padding: 0,
            background: 'transparent', border: 'none',
            color: 'var(--muted)', fontSize: 16, lineHeight: 1,
            cursor: 'pointer', borderRadius: 'var(--radius-xs)',
            opacity: 0.6,
          }}
        >×</button>
      )}
    </div>
  );
}

function BalanceRow(props: { mealType: MealType; balance: Balance }) {
  const { balance, mealType } = props;
  const empty = balance.total === 0;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
      <strong style={{ minWidth: 56, color: 'var(--ink)', fontSize: 12 }}>{MEAL_LABEL[mealType]}</strong>
      {empty ? (
        <span style={{ color: 'var(--muted)', fontStyle: 'italic' }}>
          No {mealType} meals planned yet
        </span>
      ) : (
        LABELS.map(({ key, label }) => {
          const c = balance[key];
          const isLight = c.status === 'light';
          return (
            <span key={key} style={{
              display: 'inline-block', padding: '2px 8px',
              background: isLight ? 'var(--accent-peach-bg)' : 'var(--accent-mint-bg)',
              color: isLight ? 'var(--accent-peach-ink)' : 'var(--accent-mint-ink)',
              borderRadius: 'var(--radius-pill)', fontSize: 11, fontWeight: 600,
            }}>
              {isLight ? `${label} · light` : `${label} ✓`}
            </span>
          );
        })
      )}
    </div>
  );
}
